export default function formatDateTime(date: string): string {
    return new Date(date).toLocaleString('pt-BR');
}
